import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {combineLatest} from 'rxjs';
import {filter} from 'rxjs/operators';
import {LightBoxImageType, OrderPhotosLightboxService} from './order-photos-lightbox.service';
import {timestampToFullDateTime} from '../../utility/timestamp-functions';
import {MobileViewService} from 'gelios-ng-admin-components';

@Component({
  selector: 'app-order-photos-lightbox',
  templateUrl: './order-photos-lightbox.component.html',
  styleUrls: ['../mainlightbox/main-lightbox.component.scss']
})
export class OrderPhotosLightboxComponent implements OnInit {
  protected readonly timestampToFullDateTime = timestampToFullDateTime;
  selectedImage: LightBoxImageType = null;
  @Output() showChange = new EventEmitter<boolean>();
  @Output() indexImageChange = new EventEmitter<string>();

  constructor(
    public orderPhotosLightboxService: OrderPhotosLightboxService,
    public mobileView: MobileViewService
  ) {
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
    this.hideLightbox();
  }

  ngOnInit() {
    combineLatest(
      this.orderPhotosLightboxService.images,
      this.orderPhotosLightboxService.selectedImageIndex,
    ).pipe(filter(([images, index]) => images !== null && index !== null))
      .subscribe(([images, index]) => {
        this.selectedImage = images[index];
      });
  }

  hideLightbox() {
    this.orderPhotosLightboxService.show.next(false);
  }
}
